<div class="annex-group-form-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      (click)="addGroup()"
      mat-stroked-button
      color="accent"
    ><mat-icon>add</mat-icon> <span> Dodaj grupę</span></button>

    <button
      (click)="save()" [class.spinner]="processingRequest"
      [disabled]="processingRequest || !formGroupsValid"
      mat-stroked-button color="primary"
    ><mat-icon>save</mat-icon> <span> Zapisz</span></button>

    <button
      (click)="cancel()"
      mat-stroked-button
      color="warn"
    ><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="column" fxLayoutGap="15px" fxFlex="100" *ngFor="let formGroup of formGroups.controls; index as i" [formGroup]="$any(formGroup)">

    <mat-card class="mat-elevation-z4" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
        <div fxFlex="33">
          <mat-form-field fxFlex="100">
            <mat-label>Stawka % Partner</mat-label>
            <input matInput placeholder="Stawka % Partner" formControlName="ratePaid" [required]="false">
          </mat-form-field>
        </div>

        <div fxFlex="33">
          <app-chips-input-control fxFlex label="Stawki % TU" [arrayControl]="$any(formGroup.get('rates'))"></app-chips-input-control>
        </div>
        <span fxFlex></span>
      </div>

      <mat-card class="mat-elevation-z2" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
        <h3>Progi</h3>

        <ng-container *ngFor="let thresholdFormGroup of $any(formGroup.get('thresholds')).controls; index as i" [formGroup]="thresholdFormGroup">
          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
            <div fxFlex="55px" class="list-counter-thresholds">
              <span>{{i+1}}.</span>
            </div>

            <div fxFlex>
              <app-dict
                label="Typ" [required]="false"
                dictType="threshold_type"
                [control]="$any(thresholdFormGroup.get('type'))"
              ></app-dict>
            </div>

            <div fxFlex>
              <app-dict-thresholds
                label="Próg" [required]="false"
                [insuranceCompanyId]="annex.insuranceCompany?.id"
                [control]="$any(thresholdFormGroup.get('thresholdDictionary'))"
              ></app-dict-thresholds>
            </div>

            <div fxFlex>
              <mat-form-field fxFlex>
                <mat-label>Suma od</mat-label>
                <input matInput placeholder="Suma od" formControlName="thresholdFrom" [required]="false">
              </mat-form-field>
            </div>

            <div fxFlex>
              <mat-form-field fxFlex="100">
                <mat-label>Suma do</mat-label>
                <input matInput placeholder="Suma do" formControlName="thresholdTo" [required]="false">
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-around end" class="actions-container">
              <div fxFlex>
                <button
                  (click)="removeThreshold($any(formGroup), i)"
                  mat-icon-button color="warn"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <div fxLayout="row" fxLayoutGap="15px">
          <button
            (click)="addThreshold($any(formGroup.get('thresholds')))"
            mat-stroked-button color="accent"
          ><mat-icon>add</mat-icon> <span> Dodaj próg</span></button>
        </div>
      </mat-card>

      <mat-card class="mat-elevation-z2" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
        <h3>Ryzyka</h3>

        <ng-container *ngFor="let riskFormGroup of $any(formGroup.get('risks')).controls; index as i" [formGroup]="riskFormGroup">
          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
            <div fxFlex="55px" class="list-counter">
              <span>{{i+1}}.</span>
            </div>

            <div fxFlex fxLayout="column" fxLayoutGap="15px">
              <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
                <div fxFlex>
                  <app-dict-risk-dicts
                    label="Słownik ryzyk" [required]="false"
                    [insuranceCompanyId]="annex.insuranceCompany?.id"
                    [control]="$any(riskFormGroup.get('riskDictionary'))"
                  ></app-dict-risk-dicts>
                </div>

                <div fxFlex>
                  <mat-form-field fxFlex>
                    <mat-label>Kod grupy</mat-label>
                    <input matInput placeholder="Kod grupy" formControlName="groupName" [required]="false">
                  </mat-form-field>
                </div>

                <div fxFlex>
                  <mat-form-field fxFlex>
                    <mat-label>Kod ryzyka</mat-label>
                    <input matInput placeholder="Kod ryzyka" formControlName="name" [required]="false">
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
                <div fxFlex>
                  <mat-form-field fxFlex>
                    <mat-label>Riders</mat-label>
                    <input matInput placeholder="Riders" formControlName="riders" [required]="false">
                  </mat-form-field>
                </div>

                <div fxFlex="33">
                  <app-chips-input-control fxFlex label="Stawki % TU" [arrayControl]="riskFormGroup.get('rates')"></app-chips-input-control>
                </div>

                <div fxFlex>
                  <mat-form-field fxFlex>
                    <mat-label>Stawka % Partner</mat-label>
                    <input matInput placeholder="Stawka % Partner" formControlName="ratePaid" [required]="false">
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-around end" class="actions-container">
              <div fxFlex>
                <button
                  (click)="removeRisk($any(formGroup), i)"
                  mat-icon-button color="warn"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <div fxLayout="row" fxLayoutGap="15px">
          <button
            (click)="addRisk($any(formGroup.get('risks')))"
            mat-stroked-button color="accent"
          ><mat-icon>add</mat-icon> <span> Dodaj ryzyko</span></button>
        </div>
      </mat-card>

      <div fxLayout="row" fxLayoutGap="15px">
        <span fxFlex></span>

        <button
          (click)="cloneGroup(i)"
          mat-stroked-button color="accent"
        ><mat-icon>content_copy</mat-icon> <span> Kopiuj grupę</span></button>

        <button
          (click)="removeGroup(i)"
          mat-stroked-button color="warn"
        ><mat-icon>delete</mat-icon> <span> Usuń grupę</span></button>
      </div>
    </mat-card>

  </div>

  <div fxLayout="row" fxLayoutGap="15px" *ngIf="formGroups.controls.length > 0">
    <button
      (click)="addGroup()"
      mat-stroked-button
      color="accent"
    ><mat-icon>add</mat-icon> <span> Dodaj grupę</span></button>

    <button
      (click)="save()" [class.spinner]="processingRequest"
      [disabled]="processingRequest || !formGroupsValid"
      mat-stroked-button color="primary"
    ><mat-icon>save</mat-icon> <span> Zapisz</span></button>

    <button
      (click)="cancel()"
      mat-stroked-button
      color="warn"
    ><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
